import { Box, Link } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { IListItem, INavigation } from './types';

const ScollableNavigation: React.FC<INavigation> = ({ items, pathName }) => {
	const [navItems, setNavItems] = useState<Array<IListItem>>([]);

	useEffect(() => {
		setNavItems(items);
	}, [items]);

	return (
		<Box>
			<Box as="div">
				{navItems.length > 0 &&
					navItems.map((item: IListItem, idx: number) => {
						return (
							<Box key={idx} mr={{ base: 3, md: 0 }} mb={3}>
								<Link
									p={'7px'}
									// minWidth={{ base: '100%', sm: '200px', md: 'initial' }}
									className={`AccountLink ${item.url === pathName ? 'active' : ''}`}
									href={item.url}
								>
									{item.icon}
									{item.label}
								</Link>
							</Box>
						);
					})}
			</Box>
		</Box>
	);
};

export default ScollableNavigation;
